import Image from '@next/image';

import { ConferenceSpeaker } from 'types/models/Conference';
import LinkedInIcon from 'assets/icons/linkedin.svg';
import Link from '@components/atoms/Link';
import Typography from '@components/atoms/Typography';

import classes from './ConferenceSpeakers.module.scss';

type Props = {
  speakers: ConferenceSpeaker[];
};

const ConferenceSpeakers = ({ speakers }: Props) => (
  <div className={classes.wrapper}>
    {speakers.map(({ id, contact: { address, avatar }, description, position, website }) => (
      <div key={id} className={classes.speaker}>
        <Image
          layout="fill"
          objectFit="contain"
          height={80}
          width={80}
          alt={address.fullName || ''}
          className={classes.avatar}
          resolveConfig={{
            preset: 'avatar',
            extension: avatar.extension,
            name: avatar.basename,
            width: avatar.width,
            height: avatar.height,
            productName: 'employee',
          }}
          hasIncreasedDensity={false} // todo 2x and 120px
        />
        <div>
          <Typography variant="h3" renderAs="div" className={classes.name}>
            {address.fullName}
            {!!website && (
              <Link className={classes.link} href={website}>
                <LinkedInIcon />
              </Link>
            )}
          </Typography>
          <Typography variant="h4" renderAs="div" className={classes.position}>
            {position}
          </Typography>
          <Typography variant="body2" renderAs="div" className={classes.description}>
            {description}
          </Typography>
        </div>
      </div>
    ))}
  </div>
);

export default ConferenceSpeakers;
